var _mask, _g, _path, _mask2, _g2, _mask3, _g3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgBlackWhiteBg = function SvgBlackWhiteBg(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 152 60"
  }, props), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "black-white-bg_svg__a",
    width: 24,
    height: 27,
    x: 0,
    y: 33,
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M.002 33.795h23.217V60H.002V33.795Z",
    clipRule: "evenodd"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#black-white-bg_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#080808",
    fillRule: "evenodd",
    d: "M1.015 37.748c2.573-2.03 7.315-3.953 11.434-3.953 6.095 0 10.77 2.703 10.77 9.36v16.117h-6.682v-3.847c-1.518 2.603-4.711 4.577-8.294 4.577-5.025 0-8.241-2.707-8.241-7.177 0-5.64 5.799-7.657 13.188-8.61 1.98-.253 3.027-.9 3.027-2.187 0-1.903-1.58-2.85-4.438-2.85-3.011 0-6.348 1.597-8.413 3.467l-2.35-4.897Zm6.134 14.66c0 1.51.936 2.424 2.815 2.424 3.557 0 6.11-3.04 6.11-6.777-5.766.603-8.925 1.56-8.925 4.353Z",
    clipRule: "evenodd"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#080808",
    d: "M79.547 34.522v24.75H86.7V47.35c0-5.67 3.465-7.334 5.883-7.334.943 0 2.216.27 3.058.894l1.304-6.544c-1.105-.466-2.26-.57-3.206-.57-3.678 0-5.988 1.614-7.514 4.887v-4.16h-6.678ZM130.101 33.796c-3.782 0-6.607 2.214-8.079 4.347-1.367-2.757-4.263-4.347-7.729-4.347-3.782 0-6.398 2.08-7.607 4.47v-3.743h-6.894v24.75h7.156v-12.74c0-4.577 2.418-6.767 4.678-6.767 2.044 0 3.923 1.31 3.923 4.687v14.82h7.147v-12.74c0-4.627 2.364-6.767 4.728-6.767 1.889 0 3.883 1.36 3.883 4.637v14.87h7.146V42.166c0-5.563-3.782-8.37-8.352-8.37ZM62.14 34.523h-6.48v-2.517c0-3.273 1.89-4.21 3.52-4.21 1.797 0 3.199.79 3.199.79l2.205-4.99s-2.236-1.447-6.3-1.447c-4.57 0-9.77 2.55-9.77 10.553v1.82H37.666v-2.516c0-3.273 1.89-4.21 3.516-4.21.926 0 2.172.213 3.203.79l2.206-4.99c-1.317-.767-3.432-1.447-6.302-1.447-4.57 0-9.77 2.55-9.77 10.553v1.82h-4.148v5.46h4.149v19.29h7.146v-19.29h10.848v19.29h7.146v-19.29h6.48v-5.46Z"
  })), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "black-white-bg_svg__b",
    width: 152,
    height: 60,
    x: 0,
    y: 0,
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M0 60h151.922V0H0v60Z",
    clipRule: "evenodd"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#black-white-bg_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#080808",
    d: "M66.404 59.273h7.14v-24.75h-7.14v24.75Z"
  }))), _mask3 || (_mask3 = /*#__PURE__*/React.createElement("mask", {
    id: "black-white-bg_svg__c",
    width: 152,
    height: 60,
    x: 0,
    y: 0,
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M0 60h151.922V0H0v60Z",
    clipRule: "evenodd"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#black-white-bg_svg__c)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#080808",
    d: "M108.058.001c-19.304 0-36.51 13.263-41.393 30.317h6.998c4.079-12.7 17.924-23.847 34.395-23.847 20.021 0 37.325 15.087 37.325 38.573 0 5.274-.691 10.027-1.997 14.227h6.789l.067-.23c1.112-4.333 1.678-9.04 1.678-13.997 0-26.193-19.284-45.043-43.862-45.043Z"
  }))));
};
export default SvgBlackWhiteBg;